import { NgModule } from '@angular/core';
import { TeltonikaRoutingModule } from '@huge-monorepo/shared/pages';
import { TeltonikaService } from '@huge-monorepo/portal/services';

@NgModule({
  declarations: [],
  providers: [TeltonikaService],
  imports: [TeltonikaRoutingModule],
})
export class TeltonikaModule { }
